import styled from 'styled-components'

import { Title as TitleUI, DescriptionText } from '../styles'

export const Title = styled(TitleUI)`
  margin-bottom: ${({ theme }) => theme.spaces[3]}px;
`

export const Wrapper = styled.section`
  margin-bottom: 90px;

  ${({ theme }) => theme.below.laptop`
    margin-bottom: 50px;
    padding: 0 ${theme.spaces[3]}px;
  `}
`

export const Description = styled(DescriptionText)`
  margin-bottom: 50px;

  ${({ theme }) => theme.below.laptop`
    margin-bottom: ${theme.spaces[3]}px;
  `}
`

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  ${({ theme }) => theme.below.laptop`
    justify-content: center;
  `}
`

export const ImageWrapper = styled.div`
  height: 272px;
  margin-top: ${({ theme }) => theme.spaces[4]}px;
  object-fit: cover;
  position: relative;
  width: 172px;

  ${({ theme }) => theme.below.laptop`
    margin-top: ${theme.spaces[3]}px;
    margin-right: ${theme.spaces[3]}px;
    width: 90px;
    height: 146px;

    &:last-child{
      display: none;
    }
  `}
`
